import { render, staticRenderFns } from "./FilterGender.vue?vue&type=template&id=44eab043&lang=pug&"
import script from "./FilterGender.vue?vue&type=script&lang=js&"
export * from "./FilterGender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports